import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import * as Cookies from "js-cookie";
import {ConstantsService, ConstantsService as constants} from "../../services/constants/constants.service";
import { WarningModalService } from 'src/app/services/warning-modal/warning-modal.service';
import { pageIsDirty } from 'src/app/shared/page-dirty-flag';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { EnvironmentService } from "../../services/environment/environment.service";
import { ApiService } from "../../services/api/api.service";
import { environment } from "../../../environments/environment";
import { AlertBannerService, AlertType } from "../../lib/alert-banner/alert-banner.service";

@Component({
  selector: 'app-switch-organisation-modal',
  templateUrl: './switch-organisation-modal.component.pug',
  styleUrls: ['./switch-organisation-modal.component.scss'],
  standalone: false
})
export class SwitchOrganisationModalComponent implements OnInit {
  @Input() billingFlow = false;
  availableOrgs: any[] = [];
  listOfOrgs: any[] = [];
  selectedOrgUid = Cookies.get(constants.ORG_COOKIE);
  @Output() switch = new EventEmitter();
  selectedOrg: any;
  uidPresent = false;
  defaultLogo = ConstantsService.DEFAULT_LOGO;
  environment = '';
  pageIsDirty = pageIsDirty;
  ENT_10781_SIGNUP_IMPROVEMENTS = false;

  constructor(
    private modal: WarningModalService,
    private permissions: PermissionsService,
    public _bsModalRef: BsModalRef,
    private environmentService: EnvironmentService,
    private api: ApiService,
    private alertList: AlertBannerService,
  ) { }

  ngOnInit(): void {
    this.environment = this.environmentService.getCurrentEnvironment();
    this.ENT_10781_SIGNUP_IMPROVEMENTS = this.permissions.isFeatureActivated('ent-10781-signup-improvements');
    this.uidPresent = this.availableOrgs.some(val => val.uuid === this.selectedOrgUid);
    if (this.uidPresent) {
      this.setListOfOrgs();
    }else {
      this.listOfOrgs = this.availableOrgs;
    }
  }

  setListOfOrgs() {
    this.availableOrgs.forEach((val, index) => {
      if (val.uuid === this.selectedOrgUid) {
        this.selectedOrg = val;
      }else {
        this.listOfOrgs.push(val);
      }
    })
  }

  switchOrganisation(organisation) {
    if(this.pageIsDirty()) {
      let title = $localize`Leave this page?`;
      let message = $localize`All information you have added will be lost if you navigate away.\n\nDo you want to leave this page?`;
      let cancelButton = $localize`Stay on page`;
      let agreeButton = $localize`Leave this page`;
      this.modal.confirm(title, message, false, cancelButton, agreeButton, true).subscribe(response => {
        if(response) {
          this.switch.emit(organisation);
        }
      });
    } else {
      this.switch.emit(organisation);
    }
  }

  cancel() {
    this._bsModalRef.hide();
  }

  redirectToPricing() {
    if (this.ENT_10781_SIGNUP_IMPROVEMENTS) {
      this.createNewOrganisation();
    } else {
      window.open(this.environmentService.getPricingUrl(), '_blank');
    }
  }

  private createNewOrganisation() {
    this.api.post('organisation/generate-signup-token').subscribe(
      (response: any) => {
        const token = response?.data?.token;
        const email = response?.data?.email;
        if (token && email) {
          sessionStorage.removeItem(ConstantsService.AUTH_TOKEN);
          const loginUrl = environment.LOGIN_URL;
          const redirectUrl = `${loginUrl}signup/verify?t=${encodeURIComponent(token)}&email=${encodeURIComponent(email)}`;
          window.location.href = redirectUrl;
        }
      },
      (error) => {
        console.error('Failed to generate signup token:', error);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      }
    );
  }
}
